export default __webpack_public_path__ + "static/media/q25_01.880585c9.png";